if (document.querySelector('.mobile_filter--button')) {
    document.querySelector('.mobile_filter--button').addEventListener('click', () => {
        document.querySelector('.explore_products_filters').classList.add('active')
        document.querySelector('body').style.overflow = 'hidden'
    })
}

if (document.querySelector('.close_explore_products_filters')) {
    document.querySelector('.close_explore_products_filters').addEventListener('click', () => {
        document.querySelector('.explore_products_filters').classList.remove('active')
        document.querySelector('body').style.overflow = 'scroll'
    })
}
